export default __webpack_public_path__ + "static/media/Banner - AirStrapz - Pink.243ce7f6.jpg";